<template>
  <b-modal
    v-model="show"
    title="Confirmar Eliminación"
    @hidden="onClose"
    @ok="onConfirm"
    ok-variant="danger"
    ok-title="Eliminar"
    cancel-title="Cancelar"
  >
    <p v-if="escuela">
      ¿Está seguro que desea eliminar la escuela 
      <strong>{{ escuela.nombre }}</strong>?
    </p>
    <p class="text-muted">
      <small>Esta acción no se puede deshacer.</small>
    </p>
  </b-modal>
</template>

<script>
import EscuelaService from '@/services/EscuelaService';

export default {
  name: 'DeleteEscuelaModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    escuela: {
      type: Object,
      default: null
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    async onConfirm(evt) {
      if (evt) evt.preventDefault();
      
      try {
        await EscuelaService.deleteEscuela(this.escuela.id);
        
        this.$bvToast.toast('Escuela eliminada exitosamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        });
        
        this.$emit('deleted');
        this.show = false;
      } catch (error) {
        console.error('Error al eliminar escuela:', error);
        this.$bvToast.toast('Error al eliminar la escuela', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        });
      }
    },
    onClose() {
      this.$emit('input', false);
    }
  }
};
</script>
